import React from 'react' 
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'

const CategoryOffers = ({slug, lang}) => {
    const [_] = useTranslation('global');
  return (
    <li>
    <NavLink to={`/${slug}/${lang}/panel/products/category-offers`}>
      <p className="d-inline ">{_("panel.categoryOffers")}</p>
    </NavLink>
  </li>
  )
}

export default CategoryOffers
